export function parseForm(
  form: HTMLFormElement | null,
): Record<string, unknown> {
  if (form == null) return {};
  const data = new FormData(form);
  return Object.fromEntries(data.entries());
}

export interface FormValidationRules {
  pattern?: RegExp;
  validateFn?: (value?: string) => boolean;
  errorMessage: string;
}

export function validateRules(
  formValue: string,
  validationRules: Array<FormValidationRules>,
): string {
  for (const rule of validationRules) {
    if (rule.pattern && !new RegExp(rule.pattern).test(formValue)) {
      return rule.errorMessage;
    }

    if (rule.validateFn && !rule.validateFn(formValue)) {
      return rule.errorMessage;
    }
  }

  return '';
}
